module.exports = __webpack_public_path__ + "static/media/employee-appreciation-3.2205943e.jpg";